/* Os menus do rodapé são <details>: sanfona no celular, colunas abertas
 * no desktop. CSS não abre um <details> fechado, e o Chrome mantém a
 * caixa do conteúdo sem pintar (content-visibility), então as colunas
 * saíam vazias no desktop. Quem sincroniza com o ponto de virada é isto.
 */
const query = matchMedia('(min-width: 750px)');

const sync = () => {
  document.querySelectorAll('.footer__details').forEach((details) => {
    details.open = query.matches;
  });
};

sync();
query.addEventListener('change', sync);
